module.exports = __webpack_public_path__ + "img/mouse.3f545c4a.png";